module.exports = __webpack_public_path__ + "static/stjo-2-d3c4bdbcab92ffc038f929c65546c6dc.jpg";